import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Input from "../../templates/Input";
import { CreateJob, clearJobError } from "../../store/jobSlice";
import { setPopup } from "../../store/popupSlice";

function PostJob() {
  const errorFromStore = useSelector((state) => state.job.error);
  const loading = useSelector((state) => state.job.loading);
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({});
  const [error, setError] = useState("");

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const inputFields = [
    { id: "title", label: "Title", required: true, placeholder: "Enter Title" },

    {
      id: "type",
      label: "Type",
      required: true,
      type: "select",
      options: ["Job", "Internship"],
    },
    {
      id: "description",
      label: "Job Description",
      placeholder: "Enter Job Description",
      type: "rich-text",
    },
    { id: "country", label: "Country" },
    { id: "city", label: "City" },
    { id: "company", label: "Company", required: true },
    { id: "workType", label: "Work Type" },
    { id: "experience", label: "Experience", type: "text-area" },
    { id: "batch", label: "Batch" },
    { id: "degree", label: "Qualifications", type: "rich-text" },
    { id: "applyURL", label: "Application URL", required: true },
    {
      id: "skills",
      label: "Skills Required",
      required: true,
      type: "rich-text",
    },
    {
      id: "companyDescription",
      label: "Company Description",
      type: "rich-text",
    },
    { id: "salary", label: "Salary" },
    { id: "responsibilities", label: "Responsibilities", type: "rich-text" },
  ];

  const handleChange = (e) => {
    const { id, value } = e.target;
    setFormData((prev) => ({ ...prev, [id]: value }));
    setError("");
  };

  const sanitizeInput = (value) => {
    if (!value) return "";
    let cleaned = value
      .replace(/<p><br><\/p>/gi, "")
      .replace(/<div><br><\/div>/gi, "")
      .replace(/<br\s*\/?>/gi, "")
      .replace(/&nbsp;/g, "")
      .trim();
    const temp = cleaned.replace(/<[^>]*>/g, "").trim();
    return temp === "" ? "" : cleaned;
  };

  const sanitizeFormData = (data) => {
    const sanitized = {};
    for (const key in data) {
      sanitized[key] =
        typeof data[key] === "string" ? sanitizeInput(data[key]) : data[key];
    }
    return sanitized;
  };

  const postJobFunction = async () => {
    const payload = sanitizeFormData(formData); // ✅ sanitize before save
    const result = await dispatch(CreateJob(payload));

    if (result.payload?.success) {
      setFormData({});
      setError("");
      dispatch(clearJobError());

      dispatch(
        setPopup({
          message: `Job "${result.payload.data.Title}" posted successfully!`,
          type: "success",
        })
      );
    } else {
      dispatch(
        setPopup({
          message: result.payload?.message || "Error posting job",
          type: "error",
        })
      );
    }

    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div className="min-h-screen bg-gradient-to-r from-indigo-100 to-purple-100 flex items-center justify-center px-4 py-12 mt-[9vh]">
      <div className="w-full max-w-2xl bg-white rounded-2xl shadow-2xl p-10 border-t-4 border-purple-500">
        <h2 className="text-3xl font-extrabold text-center text-purple-700 mb-8">
          Post a Job
        </h2>

        {(error || errorFromStore) && (
          <div className="bg-red-100 text-red-700 p-3 mb-6 rounded-lg shadow-sm text-center">
            {error || errorFromStore}
          </div>
        )}

        <div className="space-y-6">
          <Input
            fields={inputFields}
            onChange={handleChange}
            formData={formData}
          />
          <button
            type="button"
            disabled={loading}
            onClick={postJobFunction}
            className="w-full py-3 bg-purple-600 text-white font-semibold rounded-lg shadow hover:bg-purple-700 transition duration-300"
          >
            {loading ? "Posting Job..." : "Post Job"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default PostJob;
